import { TikTokClientError } from "./client.error";

export class GenericError extends TikTokClientError {}
